import { createFileRoute } from "@tanstack/react-router";

import MarketingLayout from "@/components/marketing/MarketingLayout";

/**
 * The chrome `/features` and its thirteen children share.
 *
 * A sibling of `_app`, not a child, for the reason `blog`, `academy`, `home`
 * and `pricing` are: these pages are public and `_app`'s `RouteGuard` would
 * bounce an anonymous visitor to sign-in.
 */
export const Route = createFileRoute("/features")({
  component: MarketingLayout,
});
